import React from 'react';
import classnames from 'classnames';
import SearchIcon from '../../Icons/Search';
import { IconSize } from '../../Icons/IconWrap';
import { BiEventType } from '../../biLogger/constants';
import BiButton from '../../biLogger/Components/BiButton';
var SearchButton = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, onClick = _a.onClick;
    return (React.createElement(React.Fragment, null,
        React.createElement(BiButton, { biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'search',
            }, className: classnames('ignore-react-onclickoutside', className), onClick: onClick },
            React.createElement(SearchIcon, { className: iconClassName, size: IconSize.MEDIUM, withPadding: true }))));
};
export default SearchButton;
//# sourceMappingURL=SearchButton.js.map